export const CLIENT_DETAILS_DRAWER_TRANSLATION = {
    'CLIENT.DETAILS.DRAWER.TITLE': 'Detalii client',
    'CLIENT.DETAILS.DRAWER.CLIENT_NAME': 'Nume client:',
    'CLIENT.DETAILS.DRAWER.CLIENT_FISCAL_IDENTIFIER': 'NIF/CIF client:',
    'CLIENT.DETAILS.DRAWER.CLIENT_HISTORY_LOGS': 'Istoric:',
    'CLIENT.DETAILS.DRAWER.CLIENT_ADMINS': 'Administratori:',
    'CLIENT.DETAILS.DRAWER.CLIENT_ADMINS.COLUMN.NAME': 'Nume',
    'CLIENT.DETAILS.DRAWER.CLIENT_ADMINS.COLUMN.EMAIL': 'E-mail',
    'CLIENT.DETAILS.DRAWER.CLIENT_ADMINS.COLUMN.PHONE_NUMBER': 'Număr de telefon'
};
